// extracted by mini-css-extract-plugin
module.exports = {"block":"Block_block__I5PWY","paddings":"Block_paddings__34F63","header":"Block_header__32BUg","title":"Block_title__1L7yv","subtitle":"Block_subtitle__1wSf0"};